import { render, staticRenderFns } from "./beaconDataForm.vue?vue&type=template&id=c66de108&"
import script from "./beaconDataForm.vue?vue&type=script&lang=js&"
export * from "./beaconDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports